import * as Yup from 'yup';
import type { HRRecallFormModel } from './HRRecallForm';

export const hrRecallFormValidationSchema = (hiddenFields: Partial<Record<keyof HRRecallFormModel, boolean>> = {}) => {
  const {
    date, time, supervisorEmail,
  } = hiddenFields;

  return Yup.object({
    supervisorEmail: supervisorEmail
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
    date: date
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
    time: time
      ? Yup.string().notRequired()
      : Yup.string().required('Il campo è obbligatorio'),
  }).test(
    'future-datetime',
    'La data e ora devono essere nel futuro',
    (values, ctx) => {
      const { date: d, time: t } = values || {};

      if (!d || !t) return true;

      const datetime = new Date(`${d}T${t}`);

      if (Number.isNaN(datetime.getTime())) return true;

      if (datetime.getTime() <= Date.now()) {
        return ctx.createError({
          path: 'date',
          message: 'La data e ora devono essere nel futuro',
        });
      }

      return true;
    },
  );
};
